import { useTagStore, jsonHeaders } from "./tag-store.js";
import {
  userIngredientTagPath,
  userIngredientTagsPath,
  bulkDestroyUserIngredientTagsPath,
  countUserIngredientTagsPath,
  prototypeUserIngredientTagsPath,
  bulkAddUserIngredientTagsPath,
  bulkRemoveUserIngredientTagsPath,
} from "routes";

export const useIngredientTagStore = () => {
  return useTagStore({
    modelName: "ingredient",
    tagModelName: "ingredient_tag",
    tagPath: userIngredientTagPath,
    countTagsPath: countUserIngredientTagsPath,
    tagsPath: userIngredientTagsPath,
    bulkDestroyTagsPath: bulkDestroyUserIngredientTagsPath,
    prototypeTagsPath: prototypeUserIngredientTagsPath,
    additionalActions: {
      async bulkAddTags({ ids, tagNames }) {
        await fetch(bulkAddUserIngredientTagsPath(this.userId), {
          method: "POST",
          headers: jsonHeaders,
          body: JSON.stringify({ ingredient_ids: ids, tags: tagNames }),
        });

        await this.loadAllTags();
      },

      async bulkRemoveTags({ ids, tagNames }) {
        await fetch(bulkRemoveUserIngredientTagsPath(this.userId), {
          method: "POST",
          headers: jsonHeaders,
          body: JSON.stringify({ ingredient_ids: ids, tags: tagNames }),
        });

        await this.loadAllTags();
      },
    },
  });
};
